// Pages éligibles au reporting web V2 : règle unique partagée par ReportingMain et l'overview
export const REPORTING_NETWORKS = ['facebook', 'instagram', 'linkedin', 'tiktok']

export function isReportingEligible(page) {
  if (!page || !REPORTING_NETWORKS.includes(page.network)) return false
  if (page.story_config && page.story_config.onlyConciergerie) return false
  if (page.isGroup) return false
  if (page.network === 'linkedin' && !/^\d+$/.test(page.network_id)) return false
  return true
}
